// Butikken i nettsidens design: trekkspill, meny, varianter, handlekurv, søk og 3D.
// Handlekurven hentes alltid ferdig regnet fra Shopify (seksjonsvisning), skriptet regner ikke selv.
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const rot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const rolig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // === topp === Pekerklassen på <html> som isTouchDevice() i src/js/main.js på www. Uten den virker verken
  // hover-underline eller fyllingen av data-hero-btn ved pekeren (reglene i _links.css krever .no-touchevents).
  const beroring = 'ontouchstart' in window || 'onmsgesturechange' in window;
  document.documentElement.classList.remove(beroring ? 'no-touchevents' : 'touchevents');
  document.documentElement.classList.add(beroring ? 'touchevents' : 'no-touchevents');
  // === /topp ===
  const kr = (ore) => Math.round(ore / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr';

  // Trekkspill: som src/js/accordion.js på nettsiden (høyde, 0,5 s)
  document.addEventListener('click', (e) => {
    const knapp = e.target.closest('[data-accordion-btn]');
    if (!knapp) return;
    const rad = knapp.closest('[data-accordion-item]');
    const mal = rad && rad.querySelector('[data-accordion-target]');
    if (!mal) return;
    const apne = knapp.getAttribute('aria-expanded') !== 'true';
    knapp.setAttribute('aria-expanded', apne);
    if (rolig) { mal.classList.toggle('hidden', !apne); mal.style.height = apne ? 'auto' : '0px'; }
    else {
      // Bare én avslutning per rad om gangen, og bare radens egen høydeovergang teller. Før kunne en
      // lukking uten synlig overgang etterlate «skjul»-beskjeden, som da lukket raden ved neste åpning.
      if (mal._ekFerdig) { mal.removeEventListener('transitionend', mal._ekFerdig); clearTimeout(mal._ekTid); }
      const ferdig = () => {
        mal.removeEventListener('transitionend', mal._ekFerdig); clearTimeout(mal._ekTid); mal._ekFerdig = null;
        if (knapp.getAttribute('aria-expanded') === 'true') mal.style.height = 'auto'; else mal.classList.add('hidden');
      };
      mal._ekFerdig = (ev) => { if (ev.target === mal && ev.propertyName === 'height') ferdig(); };
      mal.addEventListener('transitionend', mal._ekFerdig);
      mal._ekTid = setTimeout(ferdig, 800);
      if (apne) { mal.classList.remove('hidden'); mal.style.height = '0px'; void mal.offsetHeight; mal.style.height = mal.scrollHeight + 'px'; }
      else { mal.style.height = mal.scrollHeight + 'px'; void mal.offsetHeight; mal.style.height = '0px'; }
    }
    if (apne) rad.dispatchEvent(new CustomEvent('ek:aapnet', { bubbles: true }));
  });

  // Toppvideoen: noen nettlesere starter den ikke av seg selv før den er dempet i skriptet
  $$('video[autoplay]').forEach((v) => { v.muted = true; if (!rolig) { const p = v.play(); p && p.catch(() => {}); } });

  // === meny === Toppen og menyene som header.js, dropdown.js og menu.js på www (se ek-topp.liquid).
  const html = document.documentElement;
  const feste = $('[data-ek-feste]');
  const ramme = $('[data-ek-ramme]');
  const subnav = $('[data-ek-subnav]');
  const menyKnapp = $('[data-ek-meny-knapp]');
  const harVideo = !!$('[data-hero-asset="true"]');
  let apent = null;
  // Kontorstoler-menyen: stolvelgeren (utgave B) eller kolonnene; innstillingen, eller ?meny=stoler / ?meny=kolonner
  let stolMeny = ($('[data-ek-topp]') || { dataset: {} }).dataset.ekStolmeny || 'stoler';
  try {
    const valgt = new URLSearchParams(location.search).get('meny');
    if (valgt === 'stoler' || valgt === 'kolonner') sessionStorage.setItem('ek_meny', valgt);
    stolMeny = sessionStorage.getItem('ek_meny') || stolMeny;
  } catch (err) { /* privat vindu: innstillingen gjelder */ }
  const panelAv = (id) => $('[data-ek-panel="' + (id === 'kontorstoler' && stolMeny === 'stoler' && $('[data-ek-panel="stolvelger"]') ? 'stolvelger' : id) + '"]');
  // Stolvelgerens fem utgaver: bryteren øverst til høyre bytter, valget huskes i nettleseren (bare under utvelgelsen)
  const visUtgave = (n) => {
    $$('[data-ek-stolvariant]').forEach((u) => { u.hidden = u.dataset.ekStolvariant !== String(n); });
    $$('[data-ek-stolutgave]').forEach((k) => k.setAttribute('aria-pressed', String(k.dataset.ekStolutgave === String(n))));
    const panel = $('[data-ek-panel="stolvelger"]');
    if (panel && apent && !panel.hidden) settHoyde(panel.offsetHeight);
  };
  if ($('[data-ek-stolbryter]')) {
    let utgave = '4';
    try { utgave = localStorage.getItem('ek_stolutgave') || '4'; } catch (err) { /* privat vindu */ }
    visUtgave(utgave);
    $$('[data-ek-stolutgave]').forEach((k) => k.addEventListener('click', () => {
      try { localStorage.setItem('ek_stolutgave', k.dataset.ekStolutgave); } catch (err) { /* privat vindu */ }
      visUtgave(k.dataset.ekStolutgave);
    }));
  }
  // Stolvelgeren: pekeren (eller tastaturet) over en stol bytter høyre side
  $$('[data-ek-stol]').forEach((a) => {
    const vis = () => {
      $$('[data-ek-stol]').forEach((x) => x.classList.toggle('ek-valgt', x === a));
      $$('[data-ek-stol-om]').forEach((o) => { o.hidden = o.dataset.ekStolOm !== a.dataset.ekStol; });
      $$('[data-ek-stol-bilde]').forEach((o) => { o.hidden = o.dataset.ekStolBilde !== a.dataset.ekStol; });
      // Tekstene er ulikt lange: rad 2 følger høyden til panelet
      const panel = a.closest('[data-ek-panel]');
      if (panel && apent && !panel.hidden) settHoyde(panel.offsetHeight);
    };
    a.addEventListener('mouseenter', vis);
    a.addEventListener('focus', vis);
  });
  // Høyden på toppen, så sidene uten video starter under den (main padding-top i ek-butikk.css).
  // Måles bare når rad 2 står i ro: ellers skyves siden ned når en meny lukkes (Nikolai 12.10).
  if (ramme && window.ResizeObserver) {
    new ResizeObserver(() => { if (!apent && subnav && !subnav.style.height) html.style.setProperty('--ek-topp-h', ramme.offsetHeight + 'px'); }).observe(ramme);
  }
  // Gjennomsiktig over videoen når siden står øverst; skjules ved rulling ned etter 50 px (Headroom, offset 50)
  let forrigeY = window.scrollY;
  function rull() {
    const y = Math.max(0, window.scrollY);
    html.classList.toggle('ek-gjennomsiktig', harVideo && y <= 50);
    if (feste && !apent) {
      if (y > 50 && y > forrigeY) feste.classList.add('ek-skjult');
      else if (y < forrigeY || y <= 50) feste.classList.remove('ek-skjult');
    }
    if (apent === 'mobil' && Math.abs(y - forrigeY) > 2) lukk();
    forrigeY = y;
  }
  window.addEventListener('scroll', rull, { passive: true });
  rull();
  // Toppen glir inn ved lasting (header.show, 0,8 s quint.out)
  if (feste && !rolig) {
    feste.classList.add('ek-start');
    requestAnimationFrame(() => requestAnimationFrame(() => { feste.classList.remove('ek-start'); feste.classList.add('ek-kommer'); }));
    feste.addEventListener('transitionend', () => feste.classList.remove('ek-kommer'), { once: true });
  }
  function settHoyde(h) {
    if (!subnav) return;
    subnav.style.height = subnav.offsetHeight + 'px';
    void subnav.offsetHeight;
    subnav.style.height = h + 'px';
  }
  function knapper(id) {
    $$('[data-ek-meny]').forEach((k) => k.setAttribute('aria-expanded', String(k.dataset.ekMeny === id)));
    if (menyKnapp) {
      menyKnapp.setAttribute('aria-expanded', String(id === 'mobil'));
      menyKnapp.setAttribute('aria-label', id === 'mobil' ? 'Lukk meny' : 'Åpne meny');
    }
  }
  function aapne(id) {
    const panel = panelAv(id);
    if (!panel || !subnav) return;
    $$('[data-ek-panel]').forEach((p) => { if (p !== panel) { p.classList.remove('ek-inn'); p.hidden = true; } });
    apent = id;
    feste && feste.classList.remove('ek-skjult');
    html.classList.add('ek-meny-apen');
    knapper(id);
    if (panel.hidden) {
      panel.hidden = false;
      const rader = $$('[data-row]', panel).filter((r) => !r.closest('[data-accordion-target]'));
      rader.forEach((r, i) => { r.style.transitionDelay = (20 + i * 60) + 'ms'; });
      requestAnimationFrame(() => requestAnimationFrame(() => panel.classList.add('ek-inn')));
    }
    settHoyde(panel.offsetHeight);
  }
  function lukk() {
    if (!apent || !subnav) return;
    const panel = panelAv(apent);
    apent = null;
    html.classList.remove('ek-meny-apen');
    knapper(null);
    if (panel) {
      panel.classList.remove('ek-inn');
      setTimeout(() => { if (!panel.classList.contains('ek-inn')) panel.hidden = true; }, 100);
    }
    const fra = subnav.offsetHeight;
    subnav.style.height = '';
    const til = subnav.offsetHeight;
    subnav.style.height = fra + 'px';
    void subnav.offsetHeight;
    subnav.style.height = til + 'px';
    subnav.addEventListener('transitionend', function f(e) {
      if (e.propertyName !== 'height') return;
      subnav.removeEventListener('transitionend', f);
      if (!apent) subnav.style.height = '';
    });
    rull();
  }
  // Pekeren åpner (mouseenter som www), å forlate toppen lukker. Klikk og tastatur åpner og lukker.
  // Er du i gang med demo-skjemaet, blir menyen stående til du klikker utenfor eller trykker Escape.
  const iSkjema = () => !!(apent && document.activeElement && document.activeElement.closest && panelAv(apent) && panelAv(apent).contains(document.activeElement) && document.activeElement.closest('form'));
  $$('[data-ek-meny]').forEach((k) => {
    k.addEventListener('mouseenter', () => { if (html.classList.contains('no-touchevents') && !iSkjema()) aapne(k.dataset.ekMeny); });
    k.addEventListener('click', () => { if (apent === k.dataset.ekMeny) lukk(); else aapne(k.dataset.ekMeny); });
  });
  $$('[data-ek-uten-meny]').forEach((a) => a.addEventListener('mouseenter', () => {
    if (apent && apent !== 'mobil' && !iSkjema()) lukk();
  }));
  if (ramme) ramme.addEventListener('mouseleave', () => { if (apent && apent !== 'mobil' && !iSkjema() && html.classList.contains('no-touchevents')) lukk(); });
  if (menyKnapp) menyKnapp.addEventListener('click', () => { if (apent === 'mobil') lukk(); else aapne('mobil'); });
  document.addEventListener('click', (e) => { if (apent && !e.target.closest('[data-ek-ramme]')) lukk(); });
  // Trekkspillene i mobilmenyen endrer høyden: rad 2 følger med
  document.addEventListener('transitionend', (e) => {
    if (apent === 'mobil' && e.target.matches && e.target.matches('[data-accordion-target]')) settHoyde($('[data-ek-panel="mobil"]').offsetHeight);
  });
  document.addEventListener('ek:aapnet', () => { if (apent === 'mobil') setTimeout(() => settHoyde($('[data-ek-panel="mobil"]').offsetHeight), 520); });
  window.matchMedia('(min-width: 1280px)').addEventListener('change', (m) => { if (m.matches && apent === 'mobil') lukk(); if (!m.matches && apent && apent !== 'mobil') lukk(); });
  // Avtal stoldemo: Sesami-kalenderen åpnes ved å trykke Sesamis egen (skjulte) knapp i skyggetreet til <sesami-experience>.
  // Knappen tegnes før Sesami lytter på den, så vi trykker til kalendervinduet <sesami-window> finnes (maks 10 sekunder).
  // Brukes av «Velg tid for prøving» på demoproduktet og av «Velg tid» i menyen (går hit med #velg-tid).
  const apneKalender = () => {
    const start = Date.now();
    const prov = () => {
      if (document.querySelector('sesami-window')) return;
      const s = document.querySelector('sesami-experience');
      const k = s && s.shadowRoot && s.shadowRoot.querySelector('button');
      if (k) k.click();
      if (Date.now() - start < 10000) setTimeout(prov, 500);
    };
    prov();
  };
  $$('[data-ek-velg-tid]').forEach((b) => b.addEventListener('click', () => {
    const w = document.querySelector('sesami-window');
    if (w) { const k = document.querySelector('sesami-experience').shadowRoot.querySelector('button'); if (k) k.click(); } else apneKalender();
  }));
  if (location.hash === '#velg-tid') apneKalender();
  // === /meny ===
  // === flatebilder === Tilbehør: pekeren (eller tastaturet) på et punkt viser punktets bilde (Nikolai 13.10)
  $$('[data-ek-flate]').forEach((a) => {
    const vis = () => {
      const panel = a.closest('[data-ek-panel]');
      if (!panel || !$('[data-ek-flatebilde="' + a.dataset.ekFlate + '"]', panel)) return;
      $$('[data-ek-flatebilde]', panel).forEach((i) => i.classList.toggle('ek-flatebilde--vis', i.dataset.ekFlatebilde === a.dataset.ekFlate));
    };
    a.addEventListener('mouseenter', vis);
    a.addEventListener('focus', vis);
  });
  // === /flatebilder ===
  // === bildevalg === Bare under utvelgelsen av bilder (innstillingen bildevalg_prove i toppen, Nikolai 12.10):
  // klikk på bildet i Bedriftsavtale viser neste kandidat; i Tilbehør viser pekeren over et punkt
  // punktets bilde, og klikk på punktet bytter bilde i stedet for å åpne siden. Valget huskes i nettleseren,
  // og nummeret i hjørnet sier hvilket bilde som står. Kandidatene ligger i assets/ek-bildevalg.json.
  // Utsnitt (Nikolai 13.10): dra bildet for å flytte det i rammen, zoom med − og + (eller musehjulet / to fingre).
  // Det huskes per bilde og står i hjørnet. «Kopier valgene» gir bilde og utsnitt for alle flatene som tekst,
  // i samme form som innstillingen «Utsnitt på bildet» (snippets/ek-utsnitt.liquid): «x% y%», og zoom som tredje tall.
  const toppEl = $('[data-ek-topp]');
  if (toppEl && toppEl.dataset.ekBildevalgProve === 'true') {
    fetch(toppEl.dataset.ekBildevalgFil).then((r) => (r.ok ? r.json() : null)).then((data) => {
      if (!data) return;
      const hent = (slot) => { try { return Number(localStorage.getItem('ek_bv_' + slot)) || 0; } catch (err) { return 0; } };
      const lagre = (slot, i) => { try { localStorage.setItem('ek_bv_' + slot, String(i)); } catch (err) { /* privat vindu */ } };
      const naa = (slot) => { const liste = data[slot]; return liste[hent(slot) % liste.length]; };
      const posNokkel = (slot, b) => 'ek_bv_pos_' + slot + '_' + (b.id || b.navn);
      // Utsnittet som tall: x og y i prosent, z er zoom (1 = hele rammen dekket, ingen forstørring)
      const tolk = (tekst) => { const [x, y, z] = String(tekst || '50% 50%').split(' ').map(parseFloat); return { x: isNaN(x) ? 50 : x, y: isNaN(y) ? 50 : y, z: z > 1 ? z : 1 }; };
      const tekstAv = (u) => Math.round(u.x) + '% ' + Math.round(u.y) + '%' + (u.z > 1.004 ? ' ' + u.z.toFixed(2).replace(/0$/, '') : '');
      const hentUtsnitt = (slot, b) => { try { return tolk(localStorage.getItem(posNokkel(slot, b)) || b.pos); } catch (err) { return tolk(b.pos); } };
      const lagreUtsnitt = (slot, b, u) => { try { localStorage.setItem(posNokkel(slot, b), tekstAv(u)); } catch (err) { /* privat vindu */ } };
      const sett = (img, u) => {
        img._ekU = u;
        const pos = u.x + '% ' + u.y + '%';
        img.style.objectPosition = pos;
        img.style.transformOrigin = pos;
        img.style.transform = u.z > 1 ? 'scale(' + u.z + ')' : '';
      };
      const merkelapp = (boks) => {
        const slot = boks.dataset.slot; const liste = data[slot]; const i = hent(slot) % liste.length; const u = $('img', boks)._ekU;
        $('.ek-bildevalg__nr', boks).textContent = (i + 1) + '/' + liste.length + ' · ' + (liste[i].navn || '') + ' · utsnitt ' + Math.round(u.y) + ' %'
          + (Math.round(u.x) !== 50 ? ' · sideveis ' + Math.round(u.x) + ' %' : '') + (u.z > 1.004 ? ' · zoom ' + u.z.toFixed(1).replace('.', ',') + '×' : '');
      };
      const alleValg = () => Object.keys(data).map((slot) => {
        const liste = data[slot]; const i = hent(slot) % liste.length; const b = liste[i];
        return slot + ': ' + (i + 1) + '/' + liste.length + ' · ' + b.navn + ' · ' + tekstAv(hentUtsnitt(slot, b));
      }).join('\n');
      const knapp = (boks, klasse, tekst, gjor) => {
        const k = document.createElement('button'); k.type = 'button'; k.className = klasse; k.textContent = tekst;
        k.addEventListener('pointerdown', (e) => e.stopPropagation());
        k.addEventListener('click', (e) => { e.stopPropagation(); gjor(k); });
        boks.appendChild(k);
        return k;
      };
      const zoom = (boks, faktor) => {
        const img = $('img', boks); if (!img || !img._ekU) return;
        const u = { ...img._ekU, z: Math.min(4, Math.max(1, img._ekU.z * faktor)) };
        sett(img, u); lagreUtsnitt(boks.dataset.slot, naa(boks.dataset.slot), u); merkelapp(boks);
      };
      const slug = (s) => s.trim().toLowerCase().replace(/æ/g, 'ae').replace(/ø/g, 'o').replace(/å/g, 'a').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      const vis = (boks, slot) => {
        const liste = data[slot];
        if (!liste || !liste.length) return;
        boks.dataset.slot = slot;
        const b = naa(slot);
        let img = $('img', boks);
        if (!img) { img = document.createElement('img'); img.className = 'ek-dekk'; img.alt = ''; boks.appendChild(img); }
        img.removeAttribute('srcset'); img.removeAttribute('sizes');
        img.draggable = false;
        img.src = b.url;
        // Produktbilder på hvit bunn vises hele (inne: true), ellers dekker bildet rammen
        img._ekInne = !!b.inne;
        img.style.objectFit = b.inne ? 'contain' : '';
        boks.classList.toggle('ek-bildevalg--hvit', !!b.inne);
        sett(img, hentUtsnitt(slot, b));
        if (!$('.ek-bildevalg__nr', boks)) { const nr = document.createElement('span'); nr.className = 'ek-bildevalg__nr'; boks.appendChild(nr); }
        if (!$('.ek-bildevalg__kopier', boks)) {
          knapp(boks, 'ek-bildevalg__kopier', 'Kopier valgene', (k) => navigator.clipboard.writeText(alleValg()).then(() => { k.textContent = 'Kopiert'; setTimeout(() => { k.textContent = 'Kopier valgene'; }, 1500); }));
          const z = document.createElement('span'); z.className = 'ek-bildevalg__zoom'; boks.appendChild(z);
          knapp(z, '', '−', () => zoom(boks, 1 / 1.15)).setAttribute('aria-label', 'Zoom ut');
          knapp(z, '', '+', () => zoom(boks, 1.15)).setAttribute('aria-label', 'Zoom inn');
        }
        merkelapp(boks);
      };
      // Dra for utsnitt: flytter bildet innenfor rammen langs den siden som stikker utenfor (også etter zoom)
      const klem = (v) => Math.min(100, Math.max(0, v));
      const dra = (boks) => {
        let start = null;
        boks.addEventListener('pointerdown', (e) => {
          const img = $('img', boks);
          if (e.button !== 0 || !img || !img.naturalWidth || !img._ekU) return;
          e.preventDefault();
          const r = boks.getBoundingClientRect();
          const u = img._ekU;
          const skala = (img._ekInne ? Math.min : Math.max)(r.width / img.naturalWidth, r.height / img.naturalHeight) * u.z;
          start = { px: e.clientX, py: e.clientY, u, ox: img.naturalWidth * skala - r.width, oy: img.naturalHeight * skala - r.height, img, flyttet: false };
          boks.setPointerCapture(e.pointerId);
        });
        boks.addEventListener('pointermove', (e) => {
          if (!start) return;
          const dx = e.clientX - start.px; const dy = e.clientY - start.py;
          if (!start.flyttet && Math.hypot(dx, dy) < 5) return;
          start.flyttet = true;
          sett(start.img, {
            x: Math.round(start.ox > 1 ? klem(start.u.x - (dx / start.ox) * 100) : start.u.x),
            y: Math.round(start.oy > 1 ? klem(start.u.y - (dy / start.oy) * 100) : start.u.y),
            z: start.u.z,
          });
          merkelapp(boks);
        });
        const slipp = () => {
          if (!start) return;
          if (start.flyttet) {
            lagreUtsnitt(boks.dataset.slot, naa(boks.dataset.slot), start.img._ekU);
            boks.dataset.dratt = '1'; setTimeout(() => { delete boks.dataset.dratt; }, 0);
          }
          start = null;
        };
        boks.addEventListener('pointerup', slipp);
        boks.addEventListener('pointercancel', slipp);
        // Musehjulet og to fingre på styreflaten zoomer
        boks.addEventListener('wheel', (e) => { e.preventDefault(); zoom(boks, Math.exp(-e.deltaY * 0.0015)); }, { passive: false });
      };
      const neste = (boks) => {
        if (boks.dataset.dratt) return;
        const slot = boks.dataset.slot;
        const liste = data[slot];
        if (!liste) return;
        lagre(slot, (hent(slot) + 1) % liste.length);
        vis(boks, slot);
      };
      $$('[data-ek-bildevalg]').forEach((boks) => { if (!data[boks.dataset.ekBildevalg]) return; vis(boks, boks.dataset.ekBildevalg); dra(boks); boks.addEventListener('click', () => neste(boks)); });
      $$('[data-ek-bildevalg-flate]').forEach((boks) => {
        const panel = boks.closest('[data-ek-panel]');
        const punkter = $$('[data-list-item] a', panel).map((a) => ({ a, slot: 'tilbehor-' + slug(a.textContent) })).filter((x) => data[x.slot]);
        if (!punkter.length) return;
        vis(boks, punkter[0].slot);
        dra(boks);
        boks.addEventListener('click', () => neste(boks));
        punkter.forEach(({ a, slot }) => {
          a.addEventListener('mouseenter', () => vis(boks, slot));
          a.addEventListener('click', (e) => { e.preventDefault(); if (boks.dataset.slot === slot) neste(boks); else vis(boks, slot); });
        });
      });
    }).catch(() => { /* uten kandidater står bildene som før */ });
  }
  // === /bildevalg ===
  // === sok === Søkefeltet med valgene (snippets/ek-sokefelt), i søkelaget og på søkesiden. Valgene til høyre i
  // feltet som ottoFelt.js på www: «Søk i nettbutikken | Søk på hele Euklides» når du skriver, «Spør Otto» når
  // teksten ser ut som et spørsmål (spørsmålstegn eller fire ord eller flere). Enter søker i butikken.
  const ottoFinnes = () => !!(window.euklidesChat && (window.euklidesChat.spor || window.euklidesChat.fyll));
  const sokeskjemaer = $$('[data-ek-sokefelt]');
  function vurderSok(skjema) {
    const felt = $('[data-ek-sokefelt-q]', skjema);
    const boks = $('[data-ek-sokefelt-boks]', skjema);
    const mini = $('[data-ek-otto-mini]', skjema);
    const q = felt.value.trim();
    const sporsmal = q.includes('?') || q.split(/\s+/).filter(Boolean).length >= 4;
    const otto = sporsmal && ottoFinnes();
    boks.classList.toggle('har-tekst', !!q && !otto);
    boks.classList.toggle('har-otto', otto);
    if (otto && mini && !mini.innerHTML.trim() && window.EuklidesChat && window.EuklidesChat.mini) {
      try { window.EuklidesChat.mini(mini); } catch (err) { /* Otto uten figur */ }
    }
  }
  function utforSok(skjema, modus) {
    const felt = $('[data-ek-sokefelt-q]', skjema);
    const q = felt.value.trim();
    if (!q) { felt.focus(); return; }
    if (modus === 'hele') { window.location.href = 'https://www.euklides.no/sok?q=' + encodeURIComponent(q); return; }
    if (modus === 'otto') {
      const chat = window.euklidesChat;
      skjema.dispatchEvent(new CustomEvent('ek:otto', { bubbles: true }));
      felt.blur();
      if (chat && typeof chat.spor === 'function') chat.spor(q); else if (chat && chat.fyll) chat.fyll(q);
      return;
    }
    // options[prefix]=last: «atla» finner Atlas, som det gamle søkeskjemaet
    window.location.href = rot + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
  }
  sokeskjemaer.forEach((skjema) => {
    const felt = $('[data-ek-sokefelt-q]', skjema);
    felt.addEventListener('input', () => vurderSok(skjema));
    skjema.addEventListener('click', (e) => { const k = e.target.closest('[data-ek-sokevalg]'); if (k) utforSok(skjema, k.dataset.ekSokevalg); });
    skjema.addEventListener('submit', (e) => { e.preventDefault(); utforSok(skjema, 'butikk'); });
    vurderSok(skjema);
  });
  // Søkelaget (src/js/sokelag.js på www): «Søk» mørkner siden og legger feltet midt på
  const lag = $('[data-ek-sokelag]');
  if (lag) {
    const skjema = $('[data-ek-sokefelt]', lag);
    const felt = $('[data-ek-sokefelt-q]', lag);
    const aapneSok = () => {
      if (apent) lukk();
      felt.value = '';
      vurderSok(skjema);
      lag.classList.add('ek-apen');
      lag.setAttribute('aria-hidden', 'false');
      html.style.overflow = 'hidden';
      felt.focus({ preventScroll: true });
    };
    const lukkSok = () => {
      lag.classList.remove('ek-apen');
      lag.setAttribute('aria-hidden', 'true');
      html.style.overflow = '';
      felt.blur();
    };
    skjema.addEventListener('ek:otto', lukkSok);
    // Alle «Søk»-lenkene åpner laget; Cmd/Ctrl-klikk går til søkesiden som før
    document.addEventListener('click', (e) => {
      const a = e.target.closest('[data-ek-sok-aapne]');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      aapneSok();
    }, true);
    lag.addEventListener('click', (e) => {
      if (e.target.closest('[data-ek-sokelag-lukk]') || !e.target.closest('form')) lukkSok();
    });
    document.addEventListener('keydown', (e) => { if (e.code === 'Escape' && lag.classList.contains('ek-apen')) lukkSok(); });
  }
  // === /sok ===

  // Handlekurvskuff
  let forrigeFokus = null;
  const skuffSeksjon = () => document.getElementById('shopify-section-ek-kurvskuff');
  const skuff = () => $('[data-ek-skuff]');
  function settAntall(n) { $$('[data-ek-kurv-antall]').forEach((el) => { el.textContent = '(' + n + ')'; }); }
  function aapneSkuff() {
    const s = skuff(); if (!s) return;
    forrigeFokus = document.activeElement;
    s.hidden = false; document.body.classList.add('ek-last');
    const panel = $('.ek-skuff__panel', s); panel && panel.focus();
  }
  function lukkSkuff() {
    const s = skuff(); if (!s || s.hidden) return;
    s.hidden = true; document.body.classList.remove('ek-last');
    forrigeFokus && forrigeFokus.focus && forrigeFokus.focus();
  }
  // Står skuffen åpen, byttes bare tekst og priser på hver linje og summen nederst (15.10). Panelet, bildene og
  // beskjedfeltet blir stående, så skuffen ikke glir inn på nytt og blinker når antallet endres.
  function oppdaterApenSkuff(s, tmp) {
    const panel = $('.ek-skuff__panel', s), nyttPanel = $('.ek-skuff__panel', tmp);
    if (!panel || !nyttPanel) return false;
    const liste = $('.ek-linjer', panel), nyListe = $('.ek-linjer', nyttPanel);
    const bunn = $('.ek-skuff__bunn', panel), nyBunn = $('.ek-skuff__bunn', nyttPanel);
    if (!liste || !nyListe || !bunn || !nyBunn) { panel.innerHTML = nyttPanel.innerHTML; return true; }
    const fokus = document.activeElement && document.activeElement.closest('[data-ek-endre]');
    const fokusNokkel = fokus && fokus.dataset.ekEndre, fokusNavn = fokus && fokus.getAttribute('aria-label');
    const tittel = $('#ek-skuff-tittel', panel), nyTittel = $('#ek-skuff-tittel', nyttPanel);
    if (tittel && nyTittel) tittel.textContent = nyTittel.textContent;
    const gamle = new Map($$('[data-ek-linje]', liste).map((li) => [li.dataset.ekLinje, li]));
    $$('[data-ek-linje]', nyListe).forEach((nyLi, i) => {
      let li = gamle.get(nyLi.dataset.ekLinje);
      if (li) {
        gamle.delete(nyLi.dataset.ekLinje);
        const tekst = $('.ek-linje__tekst', li), nyTekst = $('.ek-linje__tekst', nyLi);
        if (tekst && nyTekst) tekst.innerHTML = nyTekst.innerHTML;
      } else li = nyLi;
      if (liste.children[i] !== li) liste.insertBefore(li, liste.children[i] || null);
    });
    gamle.forEach((li) => li.remove());
    bunn.innerHTML = nyBunn.innerHTML;
    if (fokusNokkel) {
      const k = $$('[data-ek-endre]', panel).find((x) => x.dataset.ekEndre === fokusNokkel && x.getAttribute('aria-label') === fokusNavn);
      (k || panel).focus();
    }
    return true;
  }
  function settInnSkuff(html, apen) {
    const sek = skuffSeksjon(); if (!sek || !html) return;
    const tmp = document.createElement('div'); tmp.innerHTML = html;
    const s = skuff();
    if (apen && s && !s.hidden && oppdaterApenSkuff(s, tmp)) return;
    const ny = tmp.firstElementChild;
    sek.innerHTML = ny ? ny.innerHTML : html;
    const s2 = skuff(); if (s2) s2.hidden = !apen;
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-ek-skuff-lukk]')) { lukkSkuff(); return; }
    const kurv = e.target.closest('[data-ek-kurv-aapne]');
    if (kurv && !document.body.classList.contains('ek--cart') && skuff()) { e.preventDefault(); aapneSkuff(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.code !== 'Escape') return;
    lukkSkuff();
    if (apent) { const k = apent === 'mobil' ? menyKnapp : $('[data-ek-meny="' + apent + '"]'); lukk(); k && k.focus(); }
    $$('[data-ek-forslag]').forEach((f) => { f.hidden = true; });
  });

  // Endre antall eller fjerne (skuff og kurvside)
  document.addEventListener('click', async (e) => {
    const k = e.target.closest('[data-ek-endre]');
    if (!k) return;
    k.disabled = true;
    const svar = await fetch(rot + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: k.dataset.ekEndre, quantity: Number(k.dataset.antall), sections: 'ek-kurvskuff' }),
    }).then((r) => r.json()).catch(() => null);
    if (document.querySelector('[data-ek-kurvside]')) { location.reload(); return; }
    if (svar && svar.sections) { settInnSkuff(svar.sections['ek-kurvskuff'], true); settAntall(svar.item_count); }
  });

  async function leggI(items, knapp, feilEl) {
    if (knapp) { knapp.setAttribute('aria-busy', 'true'); knapp.disabled = true; }
    if (feilEl) feilEl.hidden = true;
    try {
      const r = await fetch(rot + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: 'ek-kurvskuff' }),
      });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message || 'Kunne ikke legge i handlekurven.');
      settInnSkuff(j.sections && j.sections['ek-kurvskuff'], true);
      const kurv = await fetch(rot + 'cart.js').then((x) => x.json());
      settAntall(kurv.item_count);
      aapneSkuff();
    } catch (err) {
      if (feilEl) { feilEl.textContent = err.message; feilEl.hidden = false; }
    } finally {
      if (knapp) { knapp.removeAttribute('aria-busy'); knapp.disabled = false; }
    }
  }

  // === storvindu === Bildet stort i www sitt vindu for fargeprøver (snippets/ek-storvindu.liquid): fargesidene og
  // lagerstolene (16.10). aapne(liste, start) tar [{url, navn, zoom, velg}]; å bla kaller velg, så siden bak alltid viser
  // det kunden så sist. lastStor(url) laster et stort bilde på forhånd.
  function storvindu(vindu) {
    const vBilde = $('[data-ek-stort-bilde]', vindu), vFlate = $('[data-ek-stort-flate]', vindu), vFigur = $('[data-ek-stort-figur]', vindu), vNavn = $('[data-ek-stort-navn]', vindu);
    const store = new Map();
    const lastStor = (url) => { if (!url) return null; if (!store.has(url)) { const im = new Image(); im.src = url; store.set(url, im); } return store.get(url); };
    let liste = [], vist = -1, forrigeFokus = null, vVenter = null;
    // Det gamle bildet står til det nye er lastet (ingen blinking)
    function vis(i) {
      vist = (i + liste.length) % liste.length;
      const { url, navn, zoom } = liste[vist];
      vVenter = url;
      const im = lastStor(url);
      const sett = () => {
        if (vVenter !== url) return;
        vFlate.style.setProperty('--r', (im.naturalWidth / im.naturalHeight) || 1); vFlate.style.setProperty('--z', zoom || 1);
        vBilde.src = url; vBilde.alt = navn; vNavn.textContent = navn;
      };
      if (im.complete && im.naturalWidth) sett(); else im.addEventListener('load', sett, { once: true });
      [vist - 1, vist + 1].forEach((n) => lastStor(liste[(n + liste.length) % liste.length].url));
    }
    function velg(i) { const n = (i + liste.length) % liste.length; liste[n].velg(); vis(n); }
    function aapne(ny, start) {
      liste = ny; if (!liste.length) return;
      forrigeFokus = document.activeElement;
      vis(start); vindu.hidden = false; document.body.classList.add('ek-stort-apen');
      $('[data-ek-stort-lukk]', vindu).focus({ preventScroll: true });
    }
    function lukk() {
      if (vindu.hidden) return;
      vindu.hidden = true; document.body.classList.remove('ek-stort-apen');
      if (forrigeFokus && forrigeFokus.focus) forrigeFokus.focus({ preventScroll: true });
    }
    // Som på www: klikk på bakgrunnen eller rundt bildet lukker, krysset lukker, halvdelene blar
    vindu.addEventListener('click', (e) => {
      if (e.target === vindu || e.target === vFigur || e.target.closest('[data-ek-stort-lukk]')) lukk();
      const b = e.target.closest('[data-ek-stort-bla]'); if (b) velg(vist + Number(b.dataset.ekStortBla));
    });
    document.addEventListener('keydown', (e) => {
      if (vindu.hidden) return;
      if (e.code === 'Escape') lukk();
      else if (e.code === 'ArrowLeft') velg(vist - 1);
      else if (e.code === 'ArrowRight') velg(vist + 1);
    });
    let tx = null, ty = null;
    vindu.addEventListener('touchstart', (e) => { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }, { passive: true });
    vindu.addEventListener('touchend', (e) => {
      if (tx === null) return;
      const dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty; tx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) velg(vist + (dx < 0 ? 1 : -1));
    }, { passive: true });
    return { aapne, lastStor };
  }
  // === /storvindu ===
  // === produkt === Produktsiden: varianter, antall, kjøp, pakke (Kjøp sammen)
  // Pris med øre bare når prisen har øre, som snippets/ek-pris
  const krOre = (ore) => { const h = Math.floor(ore / 100); const o = ore % 100; return h.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') + (o ? ',' + String(o).padStart(2, '0') : '') + '\u00a0kr'; };
  // Inkl. / eks. mva (felles design med www): ett tall, knappen ved prisen bytter alle [data-ek-ore] på siden.
  // Valget huskes i informasjonskapselen «ek_mva» på hele euklides.no, så det følger med mellom www og
  // butikken (02.11.2026; localStorage alene er per adresse). localStorage er reserve. Eks. mva = inkl. ÷ 1,25,
  // rundet til hele kroner. Uten valg: inkl. mva her, eks. mva på www.
  const mvaKake = () => { const m = /(?:^|;\s*)ek_mva=(inkl|eks)/.exec(document.cookie); return m && m[1]; };
  const huskMva = (v) => {
    const domene = /(^|\.)euklides\.no$/.test(location.hostname) ? '; domain=.euklides.no' : '';
    document.cookie = 'ek_mva=' + v + domene + '; path=/; max-age=31536000; SameSite=Lax';
    try { localStorage.setItem('ek_mva', v); } catch (err) { /* valget gjelder bare denne siden */ }
  };
  let mva = 'inkl';
  try { if ((mvaKake() || localStorage.getItem('ek_mva')) === 'eks') mva = 'eks'; } catch (err) { /* privat vindu: inkl. */ }
  const belop = (el) => { const o = Number(el.dataset.ekOre); el.textContent = mva === 'eks' ? krOre(Math.round(o / 125) * 100) : krOre(o); };
  function visMva() {
    $$('[data-ek-ore]').forEach(belop);
    $$('[data-ek-mva]').forEach((k) => {
      k.textContent = mva === 'eks' ? 'eks. mva' : 'inkl. mva';
      k.setAttribute('aria-pressed', mva === 'eks' ? 'true' : 'false');
      k.setAttribute('aria-label', mva === 'eks' ? 'Prisen vises uten mva. Trykk for å vise med mva.' : 'Prisen vises med mva. Trykk for å vise uten mva.');
      k.title = mva === 'eks' ? 'Skift til inkl. mva' : 'Skift til eks. mva';
    });
  }
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-ek-mva]')) return;
    mva = mva === 'eks' ? 'inkl' : 'eks';
    huskMva(mva);
    visMva();
  });
  const ore = (n) => '<span class="ek-belop" data-ek-ore="' + n + '"></span>';
  // Leveringslinja når et tilvalg som ikke står på lager er krysset av (Nikolai 16.10, Atlas til Mirra 2): tilvalgets
  // leveringstid fra feltet custom.leveringstid_bestillingsvare («4 uker», «4 uker fra bestilling»).
  const tilvalgLevering = (t) => { const m = /(\d+)\s*uke/.exec(t || ''); return m ? 'Bestillingsvare. Leveres om ca.\u00a0' + m[1] + '\u00a0uker.' : 'Bestillingsvare. Vi bekrefter leveringstiden når du bestiller.'; };
  $$('[data-ek-produkt]').forEach((sek) => {
    const skjema = $('[data-ek-kjop]', sek);
    const json = $('[data-ek-varianter]', sek);
    if (!skjema || !json) return;
    const varianter = JSON.parse(json.textContent);
    const idFelt = $('[data-ek-variant-id]', skjema);
    const priser = $$('[data-ek-pris]'); // prisen under tittelen og prisen ved knappene
    const status = $('[data-ek-status]', sek);
    const knapp = $('[data-ek-legg-i]', skjema);
    const feil = $('[data-ek-feil]', skjema);
    const naa = $('[data-ek-kjop-naa]', skjema);
    const lt = JSON.parse(($('[data-ek-levering]', sek) || {}).textContent || '{}');
    const ltRader = $$('[data-ek-levering-rad]', sek);
    const grupper = $$('[data-ek-valg]', skjema);
    const valgt = () => grupper.map((g) => { const i = $('input:checked', g); return i ? i.value : null; });
    const finn = (v) => varianter.find((x) => x.valg.every((o, i) => o === v[i]));

    function merkUtsolgte() {
      const v = valgt();
      grupper.forEach((g, gi) => {
        $$('input', g).forEach((inp) => {
          const test = v.slice(); test[gi] = inp.value;
          const x = finn(test);
          inp.closest('.ek-fane').classList.toggle('ek-fane--ute', !x || !x.tilgjengelig);
        });
      });
    }
    function oppdater() {
      const v = finn(valgt());
      merkUtsolgte();
      if (!v) { knapp.disabled = true; ($('[data-ek-knapptekst]', knapp) || knapp).textContent = 'Finnes ikke'; return; }
      idFelt.value = v.id;
      idFelt.dispatchEvent(new Event('change', { bubbles: true }));
      priser.forEach((pris) => { pris.innerHTML = ore(v.pris) + (v.for > v.pris ? ' <s class="ek-for">' + ore(v.for) + '</s>' : ''); });
      oppdaterPakke(v); visTotal();
      visMva();
      visLevering(v);
      knapp.disabled = !v.tilgjengelig;
      if (naa) naa.disabled = !v.tilgjengelig;
      ($('[data-ek-knapptekst]', knapp) || knapp).textContent = v.tilgjengelig ? (knapp.dataset.tekst || 'Kjøp') : 'Utsolgt';
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
      if (v.bilde) {
        const fig = $('[data-media-id="' + v.bilde + '"]', sek);
        if (fig) {
          fig.parentElement.scrollTo({ left: fig.offsetLeft - 16, behavior: rolig ? 'auto' : 'smooth' });   // mobil: stripen ruller dit
          // PC (oppsett 3 og 5): det store bildet og småbildet følger valget (QA 13.10: bildet sto stille på Atlas, Oripura, Ollin)
          const figurer = $$('.ek-galleri__bilde', fig.parentElement), i = figurer.indexOf(fig);
          figurer.forEach((f, j) => { f.classList.toggle('er-valgt', j === i); f.classList.toggle('er-skjult', j !== i); });
          const smaa = $('[data-ek-smabilder]', sek);
          if (smaa) $$('button[data-nr]', smaa).forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.nr === String(i))));
        }
      }
    }
    // Samme regler som Gnister 6: på lager, bestillingsvare eller ikke på lager. Står stolen på lager, men tilvalget som er
    // krysset av ikke gjør det, gjelder tilvalgets leveringstid, og stolen kan ikke hentes med en gang (16.10).
    function visLevering(v) {
      const ltStatus = !v.tilgjengelig ? 'ute' : v.lager > 0 ? 'lager' : 'bestilling';
      const tilleggVenter = ltStatus === 'lager' && avkryss && avkryss.checked && regel && Number(pakke.dataset.tilleggLager) <= 0;
      if (status && lt.linje) { status.innerHTML = lt.linje[ltStatus]; if (status.dataset.tilstand) status.dataset.tilstand = ltStatus; }
      ltRader.forEach((r) => {
        if (tilleggVenter) { r.textContent = tilvalgLevering(pakke.dataset.tilleggLevering); if (r.dataset.tilstand) r.dataset.tilstand = 'bestilling'; return; }
        if (lt.rad) { r.innerHTML = lt.rad[ltStatus]; if (r.dataset.tilstand) r.dataset.tilstand = ltStatus; }
      });
      $$('[data-ek-henting]', sek).forEach((l) => { l.hidden = !(v.tilgjengelig && v.lager > 0) || tilleggVenter; });
    }
    skjema.addEventListener('change', (e) => { if (e.target.name && e.target.name.indexOf('ek-valg-') === 0) oppdater(); });
    merkUtsolgte();

    const antall = $('input[name=quantity]', skjema);
    $$('[data-ek-antall]', skjema).forEach((b) => b.addEventListener('click', () => {
      antall.value = Math.max(1, (Number(antall.value) || 1) + Number(b.dataset.ekAntall));
    }));
    skjema.addEventListener('submit', (e) => {
      e.preventDefault();
      leggI(kurvVarer(), knapp, feil);
    });
    // «Kjøp nå» (oppsettet to kolonner): legger varen i kurven og går rett til kassen
    if (naa) naa.addEventListener('click', async () => {
      naa.setAttribute('aria-busy', 'true'); naa.disabled = true; feil.hidden = true;
      try {
        const r = await fetch(rot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: kurvVarer() }) });
        const j = await r.json();
        if (!r.ok) throw new Error(j.description || j.message || 'Kunne ikke legge i handlekurven.');
        location.href = rot + 'checkout';
      } catch (err) { feil.textContent = err.message; feil.hidden = false; naa.removeAttribute('aria-busy'); naa.disabled = false; }
    });

    // «Full anmeldelse» bare når teksten faktisk er kuttet (Nikolai 14.10); Judge.me viser lenken under alle
    const fullAnm = () => $$('.jdgm-rev').forEach((r) => {
      const b = $('.jdgm-rev__body', r), l = $('.jdgm-rev__read-full', r);
      if (b && l) l.classList.toggle('ek-skjult', b.scrollHeight <= b.clientHeight + 1);
    });
    const fullAnmNaa = () => { fullAnm(); setTimeout(fullAnm, 1500); };
    if (document.readyState === 'complete') fullAnmNaa(); else addEventListener('load', fullAnmNaa, { once: true });
    const galleriAlle = $('[data-ek-galleri]', sek);
    // Resten av bildene lastes i bakgrunnen når siden er ferdig, så et trykk på et småbilde viser bildet med en gang (14.10)
    const lastResten = () => { if (galleriAlle) $$('img[loading=lazy]', galleriAlle).forEach((im) => { im.loading = 'eager'; }); };
    if (document.readyState === 'complete') setTimeout(lastResten, 300); else addEventListener('load', () => setTimeout(lastResten, 300), { once: true });
    // Oppsett 3: småbildene bytter det store bildet (PC)
    const sma = $('[data-ek-smabilder]', sek);
    if (sma && galleriAlle) sma.addEventListener('click', (e) => {
      const k = e.target.closest('button[data-nr]'); if (!k) return;
      const figurer = $$('.ek-galleri__bilde', galleriAlle);
      figurer.forEach((f, i) => { f.classList.toggle('er-valgt', String(i) === k.dataset.nr); f.classList.toggle('er-skjult', String(i) !== k.dataset.nr); });
      $$('button', sma).forEach((b) => b.setAttribute('aria-pressed', String(b === k)));
    });
    // Telleren under galleriet på mobil
    const galleri = $('[data-ek-galleri]', sek);
    const nr = $('[data-ek-galleri-nr]', sek);
    if (galleri && nr) galleri.addEventListener('scroll', () => {
      const b = galleri.firstElementChild ? galleri.firstElementChild.offsetWidth + (parseFloat(getComputedStyle(galleri).columnGap) || 0) : 1;
      nr.textContent = Math.min(galleri.children.length, Math.round(galleri.scrollLeft / b) + 1);
    }, { passive: true });
    // Stort bilde og piler som på fargesidene (Nikolai 16.10): dobbeltklikk på PC og trykk på mobil viser bildet i
    // husets vindu. I oppsett 3 og 5 blar halvdelene av det store bildet gjennom småbildene; et enkelt klikk venter litt
    // før det blar, så et dobbeltklikk ikke blar. Rekker det å bla før det andre klikket, blar dobbeltklikket tilbake.
    const ramme = $('[data-ek-galleri-ramme]', sek), pVindu = $('[data-ek-storvindu]', sek);
    if (ramme && galleriAlle && pVindu) {
      const { aapne } = storvindu(pVindu);
      const figurer = () => $$('.ek-galleri__bilde', galleriAlle);
      const smaKnapper = () => (sma && sma.offsetParent !== null ? $$('button[data-nr]', sma) : []);
      const valgtNr = () => {
        const k = smaKnapper();
        if (k.length) return Math.max(0, k.findIndex((b) => b.getAttribute('aria-pressed') === 'true'));
        const f = figurer()[0]; const b = f ? f.offsetWidth + (parseFloat(getComputedStyle(galleriAlle).columnGap) || 0) : 1;
        return Math.round(galleriAlle.scrollLeft / b);
      };
      // Å bla i vinduet velger det samme bildet på siden: småbildet på PC, stripen ruller dit på mobil
      const visBilde = (i) => {
        const k = smaKnapper(); if (k.length) { k[i].click(); return; }
        const f = figurer()[i]; if (f) galleriAlle.scrollTo({ left: f.offsetLeft - 16, behavior: 'auto' });
      };
      const navn = () => { const h = $('h1', sek); return h ? (h.firstElementChild || h).textContent.trim() : ''; };
      const aapneBilde = (e) => {
        const alle = figurer(), f = e.target.closest('.ek-galleri__bilde');
        aapne(alle.map((x, i) => ({ url: x.dataset.ekStort, navn: navn(), zoom: 1, velg: () => visBilde(i) })), f ? alle.indexOf(f) : valgtNr());
      };
      let blaVenter = null, blaSteg = 0;
      const bla = (steg) => { const k = smaKnapper(); if (k.length > 1) k[(valgtNr() + steg + k.length) % k.length].click(); };
      $$('[data-ek-galleri-bla]', ramme).forEach((k) => k.addEventListener('click', (e) => {
        if (e.detail > 1) return;
        clearTimeout(blaVenter); blaSteg = 0;
        blaVenter = setTimeout(() => { blaVenter = null; blaSteg = Number(k.dataset.ekGalleriBla); bla(blaSteg); setTimeout(() => { blaSteg = 0; }, 500); }, 280);
      }));
      ramme.addEventListener('dblclick', (e) => {
        if (blaVenter) { clearTimeout(blaVenter); blaVenter = null; } else if (blaSteg) { bla(-blaSteg); }
        blaSteg = 0; aapneBilde(e);
      });
      ramme.addEventListener('click', (e) => { if (window.matchMedia('(hover:none)').matches) aapneBilde(e); });
    }

    // Kjøp sammen: rabatten gis av Shopifys egne automatiske rabatter («Kjøp X, få Y», 14.10), på tilbehøret.
    // Pakken og rabatten står i ek-produkt-pakker (data-type og data-verdi); varene trenger ingen merking.
    const pakke = $('[data-ek-pakke][data-funnel]', sek);
    const regel = pakke && pakke.dataset.verdi ? { type: pakke.dataset.type, verdi: Number(pakke.dataset.verdi) } : null;
    const avkryss = pakke ? $('[data-ek-pakke-avkryss]', pakke) : null;
    // Sluttprisen (oppsett 5): stolen, pluss nakkestøtten med pakkepris når «Med» er valgt. Inkl. mva og eks. mva (÷ 1,25).
    let pakkeTillegg = 0;
    const totalEl = $('[data-ek-total]', sek);
    function visTotal() {
      if (!totalEl) return;
      const v = varianter.find((x) => String(x.id) === String(idFelt.value)); if (!v) return;
      const sum = v.pris + (avkryss && avkryss.checked && regel ? pakkeTillegg : 0);
      totalEl.innerHTML = ore(sum); visMva();
    }
    // Tilvalg med egen beskjed (servicen: kunden leverer stolen selv) får en linje i punktlista når det er krysset av.
    const punkter = $('.ek-butikk__punkter', sek);
    let merknad = null;
    if (pakke && pakke.dataset.merknad && punkter) {
      merknad = document.createElement('li');
      merknad.textContent = pakke.dataset.merknad;
      merknad.hidden = true;
      punkter.appendChild(merknad);
    }
    // Fraktlinja byttes når tilvalget har egen frakttekst (servicen: velg «Hent» i kassen).
    const fraktRad = pakke && pakke.dataset.frakt ? $('[data-ek-frakt-rad]', sek) : null;
    const fraktVanlig = fraktRad ? fraktRad.textContent : '';
    if (pakke) skjema.addEventListener('change', (e) => {
      if (e.target.name !== 'ek-tillegg') return;
      if (merknad) merknad.hidden = !e.target.checked;
      if (fraktRad) fraktRad.textContent = e.target.checked ? pakke.dataset.frakt : fraktVanlig;
      visTotal();
      const v = varianter.find((x) => String(x.id) === String(idFelt.value)); if (v) visLevering(v);
    });
    // Varene i kurven: stolen, og tilbehøret når det er krysset av (oppsett 5). Rabatten kommer av seg selv i kurven.
    function pakkeVarer(ant) {
      return [{ id: Number(idFelt.value), quantity: ant }, { id: Number(pakke.dataset.tillegg), quantity: 1 }];
    }
    function kurvVarer() {
      const ant = Math.max(1, Number(($('input[name=quantity]', skjema) || {}).value) || 1);
      return avkryss && avkryss.checked && regel ? pakkeVarer(ant) : [{ id: Number(idFelt.value), quantity: ant }];
    }
    if (pakke && !regel) { pakke.hidden = true; if (avkryss) avkryss.checked = false; }
    visTotal();
    function oppdaterPakke(v) {
      if (!pakke || !regel) return;
      const hver = v.pris + Number(pakke.dataset.tilleggPris);
      const trekk = regel.type === 'prosent' ? Math.floor(Number(pakke.dataset.tilleggPris) * regel.verdi / 100) : regel.verdi * 100;
      const sammen = hver - trekk;
      if (avkryss) {
        pakkeTillegg = sammen - v.pris;
        $('[data-ek-pakke-tillegg]', pakke).innerHTML = ore(pakkeTillegg);
        visTotal(); return;
      }
      $('[data-ek-pakke-sum]', pakke).innerHTML = ore(sammen);
      $('[data-ek-pakke-for]', pakke).innerHTML = ore(hver);
      visMva();
      const kb = $('[data-ek-pakke-knapp]', pakke); if (kb) kb.disabled = !v.tilgjengelig;
    }
    if (pakke && regel) {
      const start = varianter.find((x) => String(x.id) === String(idFelt.value));
      if (start) oppdaterPakke(start);
      const kjopBegge = $('[data-ek-pakke-knapp]', pakke);
      if (kjopBegge) kjopBegge.addEventListener('click', (e) => leggI(pakkeVarer(1), e.currentTarget, $('[data-ek-pakke-feil]', pakke)));
    }
  });
  visMva();
  // === /produkt ===
  // === konfigurator === «I din farge» (sections/ek-konfigurator.liquid): fargen og de to andre valgene velger varianten,
  // bildet byttes med en rolig overtoning, prisen og leveringstiden følger, og nakkestøtten kan legges til som egen linje.
  $$('[data-ek-ifarge]').forEach((sek) => {
    const data = JSON.parse(($('[data-ek-ifarge-data]', sek) || {}).textContent || '{}');
    const skjema = $('[data-ek-ifarge-skjema]', sek); if (!skjema || !data.varianter) return;
    const grupper = $$('[data-ek-ifarge-gruppe]', sek);
    const idFelt = $('[data-ek-ifarge-id]', sek), bilde = $('[data-ek-ifarge-bilde]', sek), feil = $('[data-ek-ifarge-feil]', sek);
    const leggKnapp = $('[data-ek-ifarge-legg-i]', sek), naaKnapp = $('[data-ek-ifarge-kjop-naa]', sek);
    const atlasValg = $('[data-ek-ifarge-atlas-valg]', sek), atlasBoks = $('[data-ek-ifarge-atlas]', sek);
    const valgt = () => grupper.map((g) => { const i = $('input:checked', g); return i ? i.value : null; });
    const finn = (v) => data.varianter.find((x) => x.valg.every((o, i) => o === v[i]));
    // Nakkestøtten i stolens farge: Aeron slår opp fargen alene, Embody «Ramme / Farge» (Atlas til Embody har valgene Ramme og Stoff)
    const atlasFor = (v) => data.atlas && (data.atlas[v[0]] || data.atlas[v[1] + ' / ' + v[0]]);
    // EOS gir dagene til stolen er klar hos HM; transporten til Oslo er én uke til (Nikolai 15.10)
    // Hardt mellomrom (15.10): «ca. 10 uker» deles aldri over to linjer
    const uker = (d) => { const u = Math.max(1, Math.round(d / 5)) + 1; return u === 1 ? 'ca.\u00a01\u00a0uke' : 'ca.\u00a0' + u + '\u00a0uker'; };
    const forhand = new Map();
    function lastBilde(url) { if (!url || forhand.has(url)) return; const im = new Image(); im.src = url; forhand.set(url, im); }
    const sma = new Map(); let smaVenter = null;
    // Hvert småbilde lastes og dekodes én gang; det ferdige bildet settes rett inn, så nettleseren aldri tegner et tomt felt
    function lastSma(url) {
      if (!sma.has(url)) sma.set(url, new Promise((ok) => {
        const im = new Image(); im.alt = '';
        im.onload = () => (im.decode ? im.decode().catch(() => {}) : Promise.resolve()).then(() => ok(im));
        im.onerror = () => ok(im); im.src = url;
      }));
      return sma.get(url);
    }
    // Merknaden om annet setestoff (Lino, Sayl, Verus) vises bare mens HMs foto står stort (15.10)
    const fotomerknad = $('[data-ek-ifarge-fotomerknad]', sek);
    const visFotomerknad = (url) => { if (fotomerknad) fotomerknad.hidden = !/-foto\.(jpe?g|png|webp)/i.test(url || ''); };
    visFotomerknad(bilde && bilde.getAttribute('src'));
    // Nikolai 13.10: ingen blinking. Det nye bildet lastes ferdig i bakgrunnen og settes inn i ett.
    let venter = null;
    function byttBilde(url, alt) {
      if (!url || bilde.getAttribute('src') === url) return;
      lastBilde(url); venter = url;
      const im = forhand.get(url);
      const sett = () => { if (venter !== url) return; bilde.src = url; bilde.alt = alt; visFotomerknad(url); };
      if (im.complete && im.naturalWidth) sett(); else im.addEventListener('load', sett, { once: true });
    }
    // Alle variantbildene lastes når siden står i ro, så byttet går rett
    const lastAlle = () => {
      [...new Set(data.varianter.map((x) => x.bilde).concat($$('[data-ek-ifarge-foto]', sek).map((k) => k.dataset.ekIfargeFoto)))].forEach(lastBilde);
      data.varianter.forEach((x) => (x.vinkler || []).forEach((b) => lastSma(b.t)));   // småbildene til alle fargene, så byttet går rett
    };
    if ('requestIdleCallback' in window) requestIdleCallback(lastAlle, { timeout: 3000 }); else setTimeout(lastAlle, 1500);
    function oppdater(forste) {
      let v = valgt();
      // Utførelser som ikke finnes for fargen skjules (satinert finnes bare på Mineral); står du på en av dem, flyttes valget til den første som finnes.
      const g1 = grupper[1];
      if (g1) {
        $$('[data-ek-ifarge-verdi]', g1).forEach((lab) => {
          const test = v.slice(); test[1] = lab.dataset.ekIfargeVerdi;
          const fins = !!data.varianter.find((x) => x.valg[0] === test[0] && x.valg[1] === test[1]);
          lab.hidden = !fins;
          if (!fins && $('input', lab).checked) { const forsteFins = $$('[data-ek-ifarge-verdi]', g1).find((l) => data.varianter.find((x) => x.valg[0] === v[0] && x.valg[1] === l.dataset.ekIfargeVerdi)); if (forsteFins) $('input', forsteFins).checked = true; }
        });
        v = valgt();
      }
      // Tillegget i pris for hvert valg i gruppe 2 og 3, mot det første valget i gruppa, med resten likt
      // (Aeron: utførelsen; Embody: ramme og fotkryss; samme pris gir ingen merknad)
      [1, 2].forEach((gi) => {
        const g = grupper[gi]; if (!g) return;
        const forste = $('[data-ek-ifarge-verdi]', g); if (!forste) return;
        const lik = (x, verdi) => x.valg.every((o, i) => (i === gi ? o === verdi : o === v[i]));
        const grunn = data.varianter.find((x) => lik(x, forste.dataset.ekIfargeVerdi));
        $$('[data-ek-ifarge-verdi]', g).forEach((lab) => {
          const x = data.varianter.find((y) => lik(y, lab.dataset.ekIfargeVerdi));
          const t = $('[data-ek-ifarge-tillegg]', lab); if (!t) return;
          const diff = x && grunn ? x.pris - grunn.pris : 0; t.innerHTML = diff > 0 ? ' + ' + ore(diff) : '';
        });
      });
      const x = finn(v);
      if (!x) return;
      // Står akkurat denne på lager som lagerstol, er det lagerstolen som legges i kurven, med lagerprisen og «På lager»
      // (Nikolai 15.10: ingen egen linje med lenke). Lagerstolen kjennes igjen på varenummeret.
      // Cosm: sifferet etter FLC sier bare om stolen kommer montert eller flatpakket, så det teller ikke.
      // Mirra 2: lagerstolen har HMs gamle varenummer (MRF…, kodene i en annen rekkefølge); nå heter den MRFN…
      const nokkel = (s) => {
        const n = (s || '').replace(/^FLC\d/, 'FLC').replace(/\s+/g, ' ').trim();
        const m = n.match(/^MRFN?(\S+) (.*)$/);
        return m ? 'MRF' + m[1] + ' ' + [...new Set(m[2].split(' '))].sort().join(' ') : n;
      };
      const lv = (data.lager || []).find((l) => l.antall > 0 && nokkel(l.sku) === nokkel(x.sku));
      idFelt.value = lv ? lv.id : x.id;

      // Uten leveringstid fra EOS sier vi ikke et tall (natt 14.10: Lino og Sayl er ikke slått opp for alle farger)
      const levering = $('[data-ek-ifarge-levering]', sek);
      levering.dataset.tilstand = lv ? 'lager' : 'bestilling';
      levering.textContent = lv ? 'På lager i Oslo. 1\u2060–\u20603\u00a0virkedagers\u00a0leveringstid.' : x.dager ? 'Bestillingsvare. Leveres om ' + uker(x.dager) + '.' : 'Bestillingsvare. Vi bekrefter leveringstiden når du bestiller.';
      // Lagerstolen med en nakkestøtte som ikke står på lager: nakkestøttens leveringstid (16.10, som på lagerstolene)
      const atLev = atlasFor(v);
      if (lv && atLev && atlasValg && atlasValg.checked && atLev.antall <= 0) { levering.dataset.tilstand = 'bestilling'; levering.textContent = tilvalgLevering(data.atlasLevering); }
      if (!forste) byttBilde(x.bilde, x.alt);
      if (fotos) { const fv = $('[data-ek-ifarge-fotovariant]', fotos); if (fv) fv.src = x.bilde; if (!forste) merkFoto($('[data-ek-ifarge-foto=""]', fotos)); }
      // Vinklene følger fargen (Nikolai 14.10): småbildene byttes til den valgte variantens, og den første (hovedbildet) merkes
      const vinkler = fotos && $('[data-ek-ifarge-vinkler]', fotos);
      // Nikolai 15.10: småbildene skal ikke blinke. De nye lastes ferdig først og byttes inn i ett, som hovedbildet.
      if (vinkler && x.vinkler && !forste) {
        const onsket = x.id; smaVenter = onsket;
        Promise.all(x.vinkler.map((b) => lastSma(b.t))).then((bilder) => {
          if (smaVenter !== onsket) return;
          vinkler.replaceChildren(...x.vinkler.map((b, i) => {
            const k = document.createElement('button');
            k.type = 'button'; k.setAttribute('aria-pressed', String(i === 0));
            k.dataset.ekIfargeFoto = b.u; k.dataset.alt = b.a; k.setAttribute('aria-label', 'Vis ' + b.a);
            k.append(bilder[i]);
            return k;
          }));
          merkFoto($('[data-ek-ifarge-foto]', vinkler));
        });
        x.vinkler.forEach((b) => lastBilde(b.u));
      }
      // Valgene i én linje under tittelen (15.10)
      $$('[data-ek-ifarge-oppsummering]', sek).forEach((o) => { o.textContent = x.valg.filter(Boolean).join(' | '); });
      // Nakkestøtten: bare der Atlas har fargen
      const at = atlasFor(v);
      if (atlasBoks) {
        atlasBoks.hidden = !at;   // finnes ikke Atlas i fargen, vises ikke valget i det hele tatt (Nikolai 13.10)
        if (!at && atlasValg) atlasValg.checked = false;
        if (at) {
          $('[data-ek-ifarge-atlas-pris]', sek).innerHTML = ore(at.pris - (data.atlasRabatt || 0));
          const forEl = $('[data-ek-ifarge-atlas-for]', sek); if (forEl) forEl.innerHTML = ore(at.pris);
          const ab = $('[data-ek-ifarge-atlas-bilde]', sek); if (ab && at.bilde) ab.src = at.bilde;
        }
      }
      // Sluttprisen følger valgene: stolen, og nakkestøtten når «Med» er valgt
      const sum = (lv ? lv.pris : x.pris) + (at && atlasValg && atlasValg.checked ? at.pris - (data.atlasRabatt || 0) : 0);
      $('[data-ek-ifarge-pris]', sek).innerHTML = ore(sum);
      visMva();
      if (!forste) { const url = new URL(location.href); url.searchParams.set('variant', x.id); history.replaceState(null, '', url); }
    }
    skjema.addEventListener('change', () => oppdater(false));
    // Småbildene: fargen som er valgt, så HMs foto. Trykk viser fotoet stort; et nytt valg viser fargen igjen (oppdater).
    const fotos = $('[data-ek-ifarge-fotos]', sek);
    const merkFoto = (knapp) => $$('[data-ek-ifarge-foto]', fotos).forEach((k) => k.setAttribute('aria-pressed', k === knapp ? 'true' : 'false'));
    if (fotos) fotos.addEventListener('click', (e) => {
      const k = e.target.closest('[data-ek-ifarge-foto]'); if (!k) return;
      merkFoto(k);
      // Det gamle bildet står til det nye er lastet (Nikolai 14.10)
      if (k.dataset.ekIfargeFoto) byttBilde(k.dataset.ekIfargeFoto, k.dataset.alt || '');
      else { const x = finn(valgt()); if (x) byttBilde(x.bilde, x.alt); }
    });
    // Bla i bildet (Nikolai 15.10): venstre og høyre halvdel som i bildekarusellen på www, sveip på mobil. Går i ring.
    function bla(steg) {
      const knapper = fotos ? $$('[data-ek-ifarge-foto]', fotos) : [];
      if (knapper.length < 2) return;
      const i = Math.max(0, knapper.findIndex((k) => k.getAttribute('aria-pressed') === 'true'));
      knapper[(i + steg + knapper.length) % knapper.length].click();
    }
    // Et dobbeltklikk viser bildet stort (Nikolai 15.10), så et enkelt klikk venter litt før det blar: blir det et
    // dobbeltklikk, blar det ikke. Rekker det å bla før det andre klikket, blar dobbeltklikket tilbake.
    let blaVenter = null, blaSteg = 0;
    $$('[data-ek-ifarge-bla]', sek).forEach((k) => k.addEventListener('click', (e) => {
      if (e.detail > 1) return;
      clearTimeout(blaVenter); blaSteg = 0;
      blaVenter = setTimeout(() => { blaVenter = null; blaSteg = Number(k.dataset.ekIfargeBla); bla(blaSteg); }, 280);
    }));
    const scene = $('[data-ek-ifarge-scene]', sek);
    if (scene) {
      let x0 = null, y0 = null;
      scene.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      scene.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) bla(dx < 0 ? 1 : -1);
      }, { passive: true });
    }
    // Bildene til fargene lastes på forhånd når pekeren eller fingeren nærmer seg, så byttet går rolig
    // Undertittelen med valgene endres bare når kunden velger, ikke når pekeren står over en prøve (Nikolai 15.10)
    $$('.ek-ifarge__farge input', sek).forEach((inp) => inp.closest('label').addEventListener('pointerenter', () => {
      const v = valgt(); v[0] = inp.value; const x = finn(v) || data.varianter.find((y) => y.valg[0] === inp.value); if (x) lastBilde(x.bilde);
    }));
    // Bildet stort i www sitt vindu for fargeprøver (Nikolai 15.10), for tekstilene og for det store bildet. Lista er
    // [{url, navn, velg}]; å bla kaller velg, så siden bak alltid viser det kunden så sist.
    const vindu = $('[data-ek-storvindu]', sek);
    if (vindu) {
      const { aapne: aapneStort, lastStor } = storvindu(vindu);

      // Tekstilene: et trykk på stoffet som alt er valgt åpner det. På PC blir et dobbeltklikk det samme (første klikk
      // velger, andre åpner), på mobil et nytt trykk. Sayl har ingen store stoffbilder (data-ek-tekstil mangler).
      const prover = $$('.ek-ifarge__farge[data-ek-tekstil]', sek);
      const tekstiler = () => prover.map((lab) => {
        const inp = $('input', lab);
        return { url: lab.dataset.ekTekstil, navn: inp.value, velg: () => { if (!inp.checked) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); } } };
      });
      let alleredeValgt = null;
      prover.forEach((lab) => {
        lab.addEventListener('pointerdown', () => { alleredeValgt = $('input', lab).checked ? lab : null; lastStor(lab.dataset.ekTekstil); });
        $('input', lab).addEventListener('click', () => {
          if (alleredeValgt === lab) aapneStort(tekstiler(), Math.max(0, prover.findIndex((l) => $('input', l).checked)));
          alleredeValgt = null;
        });
      });

      // Det store bildet: dobbeltklikk på PC, trykk på mobil (der finnes ingen klikkflater for å bla, fingeren sveiper).
      // Lista er småbildene til fargen som er valgt; navnet er valgene, som linja under tittelen.
      // Samme forstørrelse som bildet på siden (--ek-zoom per modell), så stolen fyller vinduet
      const stolZoom = () => parseFloat(getComputedStyle($('.ek-ifarge__galleri', sek) || sek).getPropertyValue('--ek-zoom')) || 1;
      const oppsummering = () => ($('[data-ek-ifarge-oppsummering]', sek) || {}).textContent || '';
      const bilder = () => (fotos ? $$('[data-ek-ifarge-foto]', fotos).filter((k) => k.offsetParent !== null) : []).map((k) => ({
        url: k.dataset.ekIfargeFoto || (finn(valgt()) || {}).bilde, navn: oppsummering(), zoom: stolZoom(), velg: () => k.click(),
      }));
      const aapneBilde = () => {
        const l = bilder();
        if (!l.length) { const x = finn(valgt()); if (x) aapneStort([{ url: x.bilde, navn: oppsummering(), zoom: stolZoom(), velg: () => {} }], 0); return; }
        aapneStort(l, Math.max(0, $$('[data-ek-ifarge-foto]', fotos).filter((k) => k.offsetParent !== null).findIndex((k) => k.getAttribute('aria-pressed') === 'true')));
      };
      if (scene) {
        scene.addEventListener('dblclick', () => {
          if (blaVenter) { clearTimeout(blaVenter); blaVenter = null; } else if (blaSteg) { bla(-blaSteg); }
          blaSteg = 0; aapneBilde();
        });
        scene.addEventListener('click', (e) => { if (window.matchMedia('(hover:none)').matches && !e.target.closest('button')) aapneBilde(); });
      }
    }
    function varer() {
      const items = [{ id: Number(idFelt.value), quantity: 1 }];
      const at = atlasFor(valgt());
      if (at && atlasValg && atlasValg.checked) items.push({ id: at.id, quantity: 1 });
      return items;
    }
    skjema.addEventListener('submit', (e) => { e.preventDefault(); leggI(varer(), leggKnapp, feil); });
    naaKnapp.addEventListener('click', async () => {
      naaKnapp.setAttribute('aria-busy', 'true'); naaKnapp.disabled = true; feil.hidden = true;
      try {
        const r = await fetch(rot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: varer() }) });
        const j = await r.json(); if (!r.ok) throw new Error(j.description || j.message || 'Kunne ikke legge i handlekurven.');
        location.href = rot + 'checkout';
      } catch (err) { feil.textContent = err.message; feil.hidden = false; naaKnapp.removeAttribute('aria-busy'); naaKnapp.disabled = false; }
    });
    oppdater(true);
  });
  // === /konfigurator ===

  // Bildekarusellen som på www (15.10): første bilde i midten, venstre og høyre halvdel blar ett bilde til midten,
  // og den går i ring. Bildene står i tre kopier; når du er kommet inn i en ytre kopi, hopper raden usynlig tilbake til midten.
  $$('[data-ek-karusell]').forEach((k) => {
    const rad = $('.ek-karusell__rad', k), celler = $$('[data-slideshow-image]', rad), n = celler.length / 3;
    if (!n || n !== Math.floor(n)) { k.dataset.klar = ''; return; }
    const midt = (c) => c.offsetLeft + c.offsetWidth / 2;
    const sentrer = (c, glatt) => rad.scrollTo({ left: midt(c) - rad.clientWidth / 2, behavior: glatt && !rolig ? 'smooth' : 'auto' });
    const naermest = () => { const m = rad.scrollLeft + rad.clientWidth / 2; return celler.reduce((a, c) => (Math.abs(midt(c) - m) < Math.abs(midt(a) - m) ? c : a)); };
    let t = null;
    rad.addEventListener('scroll', () => {
      clearTimeout(t);
      t = setTimeout(() => {
        const i = celler.indexOf(naermest()), bredde = celler[n].offsetLeft - celler[0].offsetLeft;
        if (i < n) rad.scrollLeft += bredde; else if (i >= 2 * n) rad.scrollLeft -= bredde;
      }, 150);
    }, { passive: true });
    $$('[data-ek-k]', k).forEach((b) => b.addEventListener('click', () => {
      const i = celler.indexOf(naermest());
      sentrer(celler[Math.min(celler.length - 1, Math.max(0, i + Number(b.dataset.ekK)))], true);
    }));
    const start = () => { sentrer(celler[n], false); k.dataset.klar = ''; };
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start, { once: true });
    window.addEventListener('resize', () => sentrer(naermest(), false));
  });

  // Filmen (15.10): trykk på stillbildet spiller filmen fra R2 med nettleserens kontroller
  $$('[data-ek-video]').forEach((f) => {
    const film = $('video', f), plakat = $('[data-ek-video-plakat]', f);
    $('[data-ek-video-spill]', f).addEventListener('click', () => {
      film.hidden = false; plakat.hidden = true;
      const p = film.play(); if (p) p.catch(() => {});
      film.focus();
    });
  });

  // Filter på samlingen: sendes med en gang du krysser av
  $$('[data-ek-filter]').forEach((f) => f.addEventListener('change', (e) => {
    if (e.target.type === 'checkbox' || e.target.tagName === 'SELECT') f.requestSubmit ? f.requestSubmit() : f.submit();
  }));

  // Søkeforslag mens du skriver (Shopifys forslag-søk)
  $$('[data-ek-sok]').forEach((skjema) => {
    const felt = $('input[name=q]', skjema);
    const boks = $('[data-ek-forslag]', skjema);
    let tid;
    felt.addEventListener('input', () => {
      clearTimeout(tid);
      const q = felt.value.trim();
      if (q.length < 2) { boks.hidden = true; return; }
      tid = setTimeout(async () => {
        const url = rot + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        const j = await fetch(url).then((r) => r.json()).catch(() => null);
        const p = j && j.resources && j.resources.results && j.resources.results.products || [];
        if (!p.length) { boks.innerHTML = '<p class="text-sm" style="padding:.75rem 1rem">Ingen forslag. Trykk Enter for å søke.</p>'; boks.hidden = false; return; }
        boks.innerHTML = '<ul>' + p.map((x) => '<li><a href="' + x.url + '"><figure>' + (x.image ? '<img src="' + x.image + '&width=160" alt="">' : '') + '</figure><span class="uppercase font-heading text-xs md:text-sm">' + x.title.replace(/</g, '&lt;') + '</span><span class="text-sm">' + kr(Math.round(Number(x.price) * 100)) + '</span></a></li>').join('') + '</ul>';
        boks.hidden = false;
      }, 200);
    });
    document.addEventListener('click', (e) => { if (!skjema.contains(e.target)) boks.hidden = true; });
  });

  // 3D: lastes først når raden åpnes, så siden ikke tynges ned for alle
  document.addEventListener('ek:aapnet', (e) => {
    const el = $('[data-ek-3d]', e.target);
    if (!el || el.dataset.startet) return;
    el.dataset.startet = '1';
    const modeller = JSON.parse(el.dataset.modeller);
    const nokler = Object.keys(modeller);
    const statusEl = $('[data-ek-3d-status]', el.parentElement);
    const omraade = el.closest('[data-accordion-target]');
    let valgtStr = nokler[0];
    let egen = null;
    async function vis() {
      if (!egen) {
        statusEl.textContent = 'Laster 3D …';
        const modul = await import(window.ekTreD);
        egen = modul.monter(el, statusEl, modeller);
      }
      egen.vis(valgtStr);
    }
    $$('[data-ek-3d-str] button', omraade).forEach((b) => b.addEventListener('click', () => {
      $$('[data-ek-3d-str] button', omraade).forEach((x) => x.setAttribute('aria-pressed', x === b));
      valgtStr = b.dataset.v; vis();
    }));
    vis();
  });

  // === lister === «+ Vis flere» under samlingene og søket (som src/js/flere.js på www): neste side hentes,
  // og kortene legges til under de som står. I søket legges kortene i riktig gruppe (Produkter, Sider og artikler).
  document.addEventListener('click', async (e) => {
    const lenke = e.target.closest('[data-ek-flere]');
    if (!lenke) return;
    e.preventDefault();
    if (lenke.dataset.laster) return;
    lenke.dataset.laster = '1';
    const html = await fetch(lenke.href).then((r) => r.text()).catch(() => '');
    const ny = new DOMParser().parseFromString(html, 'text/html');
    const her = $('[data-ek-flere-innhold]');
    const der = $('[data-ek-flere-innhold]', ny);
    if (!her || !der) { window.location.href = lenke.href; return; }
    $$('[data-ek-mer]').forEach((m) => m.replaceWith(...m.childNodes));
    $$('[data-ek-vis-rad]').forEach((r) => r.remove());
    const grupper = $$('[data-ek-treff]', der);
    if (grupper.length) {
      grupper.forEach((g) => {
        const mal = g.id && document.getElementById(g.id);
        const rad = mal && $$('.base-grid', mal).pop();
        if (rad) rad.append(...$$('.ek-kort', $$('.base-grid', g).pop()));
        else her.append(g);
      });
    } else {
      her.append(...der.children);
    }
    const neste = $('[data-ek-flere]', ny);
    if (neste) { lenke.href = neste.href; delete lenke.dataset.laster; } else { lenke.closest('[data-ek-flere-rad]').remove(); }
    if (typeof visMva === 'function') visMva();
  });
  // «+ Vis alle» i søket: resten av treffene ligger klare og foldes ut uten nytt søk (som www)
  document.addEventListener('click', (e) => {
    const lenke = e.target.closest('[data-ek-vis-alle]');
    if (!lenke) return;
    e.preventDefault();
    const mer = $('[data-ek-mer="' + lenke.dataset.ekVisAlle + '"]');
    if (mer) mer.replaceWith(...mer.childNodes);
    lenke.closest('[data-ek-vis-rad]').remove();
  });
  // === /lister ===
  // === referanser === Referansen i et vindu: www sin egen side med ?innebygd=1 (Nikolai 14.10). Escape, krysset,
  // klikk utenfor og beskjed fra rammen (Escape inne i sida) lukker. Ctrl/Cmd-klikk åpner fortsatt i ny fane.
  (() => {
    const vindu = $('[data-ek-refvindu]'); if (!vindu) return;
    const ramme = $('[data-ek-refvindu-ramme]', vindu);
    let forrige = null;
    const lukk = () => {
      if (vindu.hidden) return;
      vindu.hidden = true; document.body.classList.remove('ek-refvindu-apen'); ramme.src = 'about:blank';
      if (forrige) forrige.focus({ preventScroll: true });
    };
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[data-ek-referanse]');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault(); forrige = a;
      const url = new URL(a.href); url.searchParams.set('innebygd', '1');
      ramme.src = url.href; vindu.hidden = false; document.body.classList.add('ek-refvindu-apen');
      $('button[data-ek-refvindu-lukk]', vindu).focus({ preventScroll: true });
    });
    $$('[data-ek-refvindu-lukk]', vindu).forEach((x) => x.addEventListener('click', lukk));
    document.addEventListener('keydown', (e) => { if (e.code === 'Escape') lukk(); });
    window.addEventListener('message', (e) => { if (e.data === 'euk-lukk' && /^https:\/\/(www\.)?euklides\.no$/.test(e.origin)) lukk(); });
  })();
  // === /referanser ===
})();
